import styled from 'styled-components';
import { BLACK, GRAYSCALE_300, NEUTRAL_100 } from '../../styles/colors';
import { GIVONIC } from '../../styles/fonts';

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HeaderContainer = (styled.div`
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid ${NEUTRAL_100};
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HeaderHandle = (styled.div<{ color?: string }>`
  width: 50px;
  height: 4px;
  background-color: ${(props: { color?: string }) => props.color || GRAYSCALE_300};
  border-radius: 12px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HeaderTitle = (styled.span<{ $uppercase?: boolean }>`
  font-family: ${GIVONIC.regular};
  font-size: 14px;
  color: ${BLACK};
  text-transform: ${(props: { $uppercase?: boolean }) => props.$uppercase ? 'uppercase' : 'none'};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BottomSheetPlainHeader = (styled.div`
  width: 100%;
  height: 10px;
  background-color: white;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
